/* fc 2026-10-14 US DDP: keeps the "If shipped to US" line item property true for the
   visitor's CURRENT country. A shopper who added items as a US visitor and then switched country
   (or the reverse) would otherwise carry a stale line into checkout.
   Value = the LINE total ("$3.20 non-refundable duty included" for 2 x $1.60), so a quantity change needs a pass too.
   One pass, run on cart drawer open, after a product form add, after a drawer quantity change and on
   cart page load (a cart page quantity change reloads the page, so that is covered):
   GET /?section_id=fc-us-ddp-sync (the server works out gate, rates and wanted value per line),
   then one /cart/change.js per line that differs; lines already in sync cost nothing.
   Any error aborts silently, nothing retries. Storefront calls only, no Admin API. */
(function () {
  'use strict';
  var NAME = 'If shipped to US';
  // Earlier keys (2026-10-14 afternoon and morning builds): blanked in the same pass as NAME is set.
  var OLD = ['Import duties for US delivery', 'US import duties included'];
  var busy = false, again = false, changed = false; // changed survives a rerun, so its refresh is not lost

  var reloaded = false;
  try { reloaded = sessionStorage.getItem('fc-ddp-reloaded') === '1'; sessionStorage.removeItem('fc-ddp-reloaded'); } catch (e) {}

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function isCartPage() { return !!(window.themeVariables && themeVariables.settings && themeVariables.settings.pageType === 'cart'); }

  function sync() {
    if (busy) { again = true; return; } // a trigger during a pass gets exactly one more pass
    busy = true;
    fetch(root() + '?section_id=fc-us-ddp-sync')
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('script[type="application/json"]');
        var lines = JSON.parse(el.textContent);
        // Sequential: changing a line's properties changes only that line's key, the others stay valid.
        return lines.reduce(function (p, l) {
          // Liquid's json filter prints line_item.properties as [[name, value], ...], not an object.
          var props = {};
          (l.props || []).forEach(function (kv) { props[kv[0]] = kv[1]; });
          if ((props[NAME] || '') === l.want && !OLD.some(function (k) { return props[k]; })) return p;
          // Shopify ignores properties:{} and cannot drop one key, so "remove" = blank value. Checkout, the
          // order page, line-item.liquid and the stock emails all skip blank properties (checked 2026-10-14).
          props[NAME] = l.want;
          OLD.forEach(function (k) { if (props[k]) props[k] = ''; });
          return p.then(function () {
            return fetch(root() + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: l.key, quantity: l.qty, properties: props })
            }).then(function (r) { if (!r.ok) throw new Error('change ' + r.status); changed = true; });
          });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; sync(); return; }
        if (!changed) return;
        changed = false;
        // Line keys changed, so the rendered cart must refresh (Impact itself reloads the cart page).
        // cart:refresh is not cart:change, so it does not re-trigger this routine.
        if (!isCartPage()) { document.dispatchEvent(new CustomEvent('cart:refresh')); return; }
        // Loop guard: a page this routine reloaded never reloads again (one hop), whatever the values say.
        if (reloaded) return;
        try { sessionStorage.setItem('fc-ddp-reloaded', '1'); } catch (e) { return; }
        window.location.reload();
      });
  }

  document.addEventListener('dialog:after-show', function (e) { if (e.target && e.target.id === 'cart-drawer') sync(); });
  document.addEventListener('variant:add', sync);
  // Drawer quantity change. Impact swaps the drawer HTML 1250 ms after it (theme.js _onCartChanged), with the
  // old line keys; start after that, or our refresh lands first and gets overwritten.
  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.baseEvent === 'line-item:change') setTimeout(sync, 1300);
  });
  if (isCartPage()) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  }
})();
